/*
 * Copyright (c) AXA Group Operations Spain S.A.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

const { Stopwords } = require('@nlpjs/core');

class StopwordsEn extends Stopwords {
  constructor(container, words) {
    super(container);
    this.name = 'stopwords-en';
    this.dictionary = {};
    const list = words || [
      'about',
      'above',
      'after',
      'again',
      'all',
      'also',
      'am',
      'an',
      'and',
      'another',
      'any',
      'are',
      'as',
      'at',
      'be',
      'because',
      'been',
      'before',
      'being',
      'below',
      'between',
      'both',
      'but',
      'by',
      'came',
      'can',
      'cannot',
      'come',
      'could',
      'did',
      'do',
      'does',
      'doing',
      'during',
      'each',
      'few',
      'for',
      'from',
      'further',
      'get',
      'got',
      'has',
      'had',
      'he',
      'have',
      'her',
      'here',
      'him',
      'himself',
      'his',
      'how',
      'if',
      'in',
      'into',
      'is',
      'it',
      'its',
      'itself',
      'like',
      'make',
      'many',
      'me',
      'might',
      'more',
      'most',
      'much',
      'must',
      'my',
      'myself',
      'never',
      'now',
      'of',
      'on',
      'only',
      'or',
      'other',
      'our',
      'ours',
      'ourselves',
      'out',
      'over',
      'own',
      'said',
      'same',
      'see',
      'should',
      'since',
      'so',
      'some',
      'still',
      'such',
      'take',
      'than',
      'that',
      'the',
      'their',
      'theirs',
      'them',
      'themselves',
      'then',
      'there',
      'these',
      'they',
      'this',
      'those',
      'through',
      'to',
      'too',
      'under',
      'until',
      'up',
      'very',
      'was',
      'way',
      'we',
      'well',
      'were',
      'what',
      'where',
      'when',
      'which',
      'while',
      'who',
      'whom',
      'with',
      'would',
      'why',
      'you',
      'your',
      'yours',
      'yourself',
      'a',
      'b',
      'c',
      'd',
      'e',
      'f',
      'g',
      'h',
      'i',
      'j',
      'k',
      'l',
      'm',
      'n',
      'o',
      'p',
      'q',
      'r',
      's',
      't',
      'u',
      'v',
      'w',
      'x',
      'y',
      'z',
      '$',
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      '0',
      '_',
    ];
    this.build(list);
  }
}

module.exports = StopwordsEn;
